import React, { useMemo } from 'react';

import { Stack } from '@atlaskit/primitives/compiled';
import { MenuList } from '@atlaskit/side-nav-items/menu-list';
import { type GlobalShortcutsProps, ShortcutMenuItem } from '@atlassian/global-shortcuts';
import type { ProductLink } from '@atlassian/navigation-bff-data-provider';

import type { MappedGlobalShortcutsItem } from './types';

export interface ShortcutsMenuProps extends Pick<
	GlobalShortcutsProps,
	'shortcutItems' | 'forceStatic' | 'product' | 'openInSameTab'
> {
	invitedAppProductLinks: Record<string, ProductLink[]>;
}

export const ShortcutsMenu = ({
	shortcutItems = [],
	forceStatic,
	product,
	openInSameTab,
	invitedAppProductLinks,
}: ShortcutsMenuProps) => {
	const mappedShortcutItems: Array<MappedGlobalShortcutsItem> = useMemo(() => {
		return shortcutItems
			.map((item) => {
				if (item.type === 'link' && item.apsKey && invitedAppProductLinks[item.apsKey]) {
					const key = item.apsKey;
					const filteredProductLinks = invitedAppProductLinks[item.apsKey];

					// we only want to take single link items as we are not supporting expand menus
					if (filteredProductLinks.length === 1 && !item.url) {
						return {
							...item,
							key,
							url: filteredProductLinks[0].url,
						};
					}
				}

				return null;
			})
			.filter(Boolean) as Array<MappedGlobalShortcutsItem>;
	}, [shortcutItems, invitedAppProductLinks]) as Array<MappedGlobalShortcutsItem>;

	return (
		<Stack testId="shortcuts-menu">
			<MenuList>
				{mappedShortcutItems.map((shortcut) => (
					<ShortcutMenuItem
						key={shortcut.key}
						shortcut={shortcut}
						forceStatic={forceStatic}
						product={product}
						openInSameTab={openInSameTab}
					/>
				))}
			</MenuList>
		</Stack>
	);
};
